import {Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {LineasComponent} from './lineas/lineas.component';
import {ParadasComponent} from './paradas/paradas.component';
import {MapaComponent} from './mapa/mapa.component';
import {MapaContainerComponent} from './mapaContainer/mapaContainer.component';
import {DomSanitizer} from '@angular/platform-browser';
import {LineObject} from './DTOs/LineObject.component';
import {ItinerarioObject} from './DTOs/ItinerarioObject.component';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var i18nVS: any;
declare var colorLineaClicada: any;
declare var colorCity: any;
declare var viewMode: any;
declare var useRtiApi: any;
declare var companyId: any;

declare var idLineaClicada: any;
let mapLoad = false;

@Component({
	selector: 'app-service-information',
	templateUrl: './service-information.component.html',
	styleUrls: ['./service-information.component.css']
})

export class AppComponent implements OnInit {
	/*------------------------------------------------ Variables VSC -------------------------------------------------*/
	@ViewChild(ParadasComponent) childParadas: ParadasComponent; // Para tener acceso a las funciones de este componente
	@ViewChild(LineasComponent) childLineas: LineasComponent;
	@ViewChild(MapaContainerComponent, {read: ViewContainerRef}) container; // Preparar el contenedor del mapa

	i18nL = i18nVS;

	// Clases
	lineasClass = 'visible';
	paradasClass = 'invisible';
	showLinesButtonClass = '';
	errorEnLosWebservicesClass = 'invisible';

	icono = '';

	titulo = this.i18nL.alsa_lineas;
	subtitulo = this.i18nL.serviceInformation_selecionLinea;

	activeLine: LineObject;
	activeItinerary: ItinerarioObject;

	/*----------------------------------------------- Funciones ----------------------------------------------------*/
	public goToLineas() {
		this.tabControl(1);
		idLineaClicada = -1;
	}

	public goToSchedules() {
		(<HTMLDivElement>document.getElementById("scheduleSection")).scrollIntoView();
	}

	public goToPrices() {
		(<HTMLDivElement>document.getElementById("scheduleSection")).scrollIntoView();
	}

	public callParadas(line: LineObject) {
		this.childParadas.showStops(line);
		this.tabControl(2);
		this.callMap();
	}

	public callMap() {
		if (!mapLoad) {
			mapLoad = true;
			this.createComponents(MapaComponent);
		}
	}

	public createComponents(component) {
		const factory = this.componentFactoryResolver.resolveComponentFactory(component);
		const ref = this.container.createComponent(factory, 0);

		ref.changeDetectorRef.detectChanges();
	}

	public removeMap() {
		if (mapLoad) {
			// Esto elimina el primer componente creado dinámicamente, en este caso será siempre el mapa
			this.container.remove(0);
			mapLoad = false;
		}
	}

	public tabControl(tab) { // 1 - lineas, 2 - paradas

		// Si se clica el boton de ir atras se volveran a mostrar las lineas
		if (tab !== 1) { // Si no estamos ya en lineas
			var url = window.location.href;
			if (url[url.length - 1] !== '#') { // Si la url no tenia ya la almohadilla
				window.location.href = window.location.href + '#'; // Se le añade esto a la URL para que se pueda ir atras
			}
		}

		// Inicializamos
		this.lineasClass = 'invisible';
		this.paradasClass = 'invisible';
		if(viewMode === '2') {
			this.showLinesButtonClass = 'invisible';
		}

		switch (tab) {
			case 1: {
				this.lineasClass = 'visible';
				this.removeMap();
				break;
			}
			case 2: {
				this.paradasClass = 'visible';
				this.removeMap();
				break;
			}
			default: {
				console.log('Unregister tabControlLineas');
			}
		}

	}

	public onWebServiceError() {
		this.errorEnLosWebservicesClass = '';
		window.scrollTo(0, 0);
	}

	public getBackground() {
		if (colorLineaClicada.includes("#")) {
			return this._sanitizer.bypassSecurityTrustStyle(colorLineaClicada);
		}
		return this._sanitizer.bypassSecurityTrustStyle("#" + colorLineaClicada);
	}

	public selectItinerary(itinerario: ItinerarioObject) {
		// Por si se clica en el itinerario ya activo
		if (itinerario.getId() !== this.activeItinerary.getId() || itinerario.getId_linea() !== this.activeItinerary.getId_linea()) {
			this.activeItinerary = itinerario;
			this.childParadas.mostrarItinerario(itinerario.getId(), itinerario.getId_linea());
		}
	}

	/*--------------------------------------------- Eventos ------------------------------------------------------*/
	ngOnInit() {
		this.tabControl(1);
	}

	onLineSelected(line: LineObject): void {
		this.childParadas.verBusesEnDirectoActivo = false;
		this.childParadas.useRtiApi = (useRtiApi === 'true');
		let actualColor = line.getColor() || colorCity;
		if (!actualColor.includes('#')) {
			actualColor = '#' + actualColor;
		}
		colorLineaClicada = actualColor;
		this.activeItinerary = line.getItinerarios()[0];
		this.activeLine = line;
		this.callParadas(line);
	}

 	private delay(ms: number) {
		return new Promise(resolve => {
			setTimeout(resolve, ms);
		});
	} 
	
	private async showLineDirectly(line) {
		await this.delay(1000);
		this.childLineas.setIdLinea(line[0].getId());
	}

	onLinesLoad(line) {
		this.childParadas.linesJson = line;
		if(viewMode === '2' && line.length === 1){
			this.childParadas.companyId = companyId
			this.showLineDirectly(line);
		}
	}

	/*--------------------------------------------- Constructores ------------------------------------------------*/
	constructor(private componentFactoryResolver: ComponentFactoryResolver,
				private viewContainerRef: ViewContainerRef, private _sanitizer: DomSanitizer) {
	}
}



// WEBPACK FOOTER //
// ./src/app/service-information.component.ts